import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { Mypipe } from './datePipeService'

@NgModule({
  imports: [
    CommonModule,
    AgmCoreModule
  ],
  declarations: [Mypipe],
  exports: [Mypipe]
})
export class MyPipesModule  { }
